'use strict';

import EmptyRouterView from '../../app/views/EmptyRouterView.vue';

export const authRoutes = [
  {
    path: '/signup',
    name: 'signup',
    meta: {
      layout: 'LoginLayout',
    },
    component: () => import('../views/SignupView.vue'),
  },
  {
    path: '/login',
    name: 'login',
    meta: {
      layout: 'LoginLayout',
    },
    component: () => import('../views/LoginView.vue'),
  },
  {
    path: '/forgot-password',
    name: 'forgot-password',
    meta: {
      layout: 'LoginLayout',
    },
    component: () => import('../views/ForgotPassword.vue'),
  },
  {
    path: '/access',
    name: 'access',
    meta: {
      layout: 'LoginLayout',
    },
    component: () => import('../views/AccessView.vue'),
  },
];
